/**
 * A goods removal carries no status column of its own: its "state" is the one of
 * the exit note (bon de sortie) it is attached to. ExitNote::cancel() releases
 * its removals (exitNote back to null), so the presence of the IRI is enough to
 * tell the two situations apart.
 */
export class GatePassStatusConstant {
  static PENDING_ID = "PENDING";
  static ON_EXIT_NOTE_ID = "ON_EXIT_NOTE";

  static OPTIONS = {
    [this.PENDING_ID]: {
      label: "En attente de bon de sortie",
      color: "orange",
    },
    [this.ON_EXIT_NOTE_ID]: {
      label: "Sur bon de sortie",
      color: "green",
    },
  };

  static getStatusKey = (
    gatePass?: { exitNote?: string | null } | null
  ): string =>
    gatePass?.exitNote
      ? GatePassStatusConstant.ON_EXIT_NOTE_ID
      : GatePassStatusConstant.PENDING_ID;
}

/**
 * RemovalSource enum: BOOKING for a removal created from a booking, DIRECT when
 * DirectRemovalService creates it from a debarkation storage pointing.
 */
export class RemovalSourceConstant {
  static BOOKING_ID = "BOOKING";
  static DIRECT_ID = "DIRECT";

  static OPTIONS = {
    [this.BOOKING_ID]: {
      label: "Booking",
      color: "blue",
    },
    [this.DIRECT_ID]: {
      label: "Direct",
      color: "purple",
    },
  };
}

/**
 * VehicleType enum, shared by every BookingControl subclass.
 */
export class GatePassVehicleTypeConstant {
  static INTERNAL_ID = "INTERNAL";
  static PARTICULAR_ID = "PARTICULAR";
}
